import { useSelector } from 'react-redux';
import { BaseCellWrapper } from 'modules/experiments/components/takeover/styled';
import { getChooseCampaignSearch } from 'modules/experiments/ducks/selectors';
import { MemoSearchableText } from 'ui-beta/searchableText';

export const IdCell = ({ value, isDisabled = false }: { value: string; isDisabled?: boolean }) => {
  const search = useSelector(getChooseCampaignSearch);

  return (
    <BaseCellWrapper $isDisabled={isDisabled}>
      <MemoSearchableText isCaseSensitive={false} text={value} searchText={search || ''} />
    </BaseCellWrapper>
  );
};
